import { CreateInstrumentItem, DuplicateFinding } from '../../../services/fundingApi';

export interface DuplicateRow {
    line: number;
    product: string;
    quantity: number;
    dueDate: string;
    reasons: string[];
}

const SAO_PAULO = 'America/Sao_Paulo';

export const registeredAtLabel = (createdAt: string | null): string => {
    if (!createdAt) return '';
    const date = new Date(createdAt);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleTimeString('pt-BR', { timeZone: SAO_PAULO, hour: '2-digit', minute: '2-digit' });
};

const existingReason = (existing: DuplicateFinding['existing'][number]): string => {
    const command = existing.commandNumber != null ? ` (comando ${existing.commandNumber})` : '';
    const at = registeredAtLabel(existing.createdAt);
    return `Já cadastrada hoje${at ? ` às ${at}` : ''}${command}`;
};

const inBatchReason = (lines: number[]): string =>
    lines.length === 1 ? `Repetida na linha ${lines[0]}` : `Repetida nas linhas ${lines.join(', ')}`;

export const buildDuplicateRows = (findings: DuplicateFinding[], items: CreateInstrumentItem[]): DuplicateRow[] =>
    findings
        .filter((finding) => items[finding.index] !== undefined)
        .map((finding) => {
            const item = items[finding.index];
            const reasons = finding.existing.map(existingReason);
            if (finding.inBatch.length > 0) reasons.push(inBatchReason(finding.inBatch.map((index) => index + 1)));
            return { line: finding.index + 1, product: item.product, quantity: item.quantity, dueDate: item.due_date, reasons };
        });
